import { useLocation } from 'react-router-dom';

const REFERRAL_PARAM = 'referral';

// The inbound referral token from `?referral=`, or null on a normal booking visit.
export const useReferralToken = (): string | null =>
  new URLSearchParams(useLocation().search).get(REFERRAL_PARAM);
